<ng-container *ngIf="_sorts">
    <div class="sort font-5 font-weight-bold uppercase" [ngClass]="{'mobile': mobile}">
        <span>Sort By:</span>
        <div class="sort__container">
        <span *ngIf="selectedSort" [class.is-active-dropdown]="sortActive" class="sort__trigger font-2" (click)="toggleSort()">
                <span class="sort__trigger--label">
                {{ selectedSort.label }}
            </span>
        </span>
        <span class="sort__dropdown"  [class.active]="sortActive" [class.left]="position === 'left'">
          <label *ngFor="let item of _sorts" class="products-list__filters__parent custom-control custom-radio font-5 mb-2">
              <input value="{{ item.id }}" name="sort" class="custom-control-input radio-dark-gray" type="radio"
                     (change)="updateSort(item)" [checked]="item.selected">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{ item.label }}</span>
          </label>
        </span>
        </div>

        <button class="btn btn-icon large with-border btn-direction with-shadow background-white btn-direction" [ngClass]="{'visible': hasDirection}"
                (click)="toggleDirection()"
                [title]="selectedSort?.directionDescription">
            <i class="fas" [ngClass]="sortDirectionClass"></i>
        </button>
    </div>
</ng-container>
